export default __webpack_public_path__ + "static/underline-15-f0a3cc835d103ddb7d1d877d2ffd36db.svg";